import {
  Alert,
  Button,
  ButtonToolbar,
  Col,
  InputPicker,
  Form,
  FormControl,
  FormGroup,
  Panel,
  ControlLabel,
  Schema,
  FlexboxGrid,
} from 'rsuite';
import React, { useState, useEffect } from 'react';

import { TicketApi } from '../../services/api/ticket';
import { UserApi } from '../../services/api/user';
import { compose } from 'redux';
import styled from '@emotion/styled';
import { Router } from 'utils/with-i18next';
import { useRouter } from 'next/router';
import { pickBy } from 'lodash';
import { TicketInfoModal } from 'components/Modals/TicketInfoModal';
import SlackFeedback from 'components/SlackFeedback';

const H6 = styled('h6')`
  font-size: 21px;
  font-weight: 400;
`;

const Model = Schema.Model({
  comment: Schema.Types.StringType().isRequired('This field is required'),
  status: Schema.Types.StringType().isRequired('This field is required'),
});

export function UpdateZendeskTicket() {
  const {
    query: { id: ticketId },
  } = useRouter();

  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [form, setForm] = useState({
    comment: '',
    status: 'closed',
  });
  const [ticket, setTicket] = useState({});
  const [user, setUser] = useState({});
  const [showTicketInfo, setShowTicketInfo] = useState(false);
  const [openSupport, setOpenSupport] = useState(false);

  useEffect(() => {
    TicketApi.getTicketById(ticketId).then(res => {
      if (res.data.propertyUserId) {
        UserApi.getUser(res.data.propertyUserId).then(res => setUser(res.data));
        setTicket(res.data);
      }
    });
  }, []);

  const statusData = [
    { label: 'Open', value: 'open' },
    { label: 'Closed', value: 'closed' },
    { label: 'Solved', value: 'solved' },
    { label: 'Pending', value: 'pending' },
  ];

  /**
   * call API
   */
  const validate = () => {
    const c = pickBy(Model.check(form), v => v.hasError);
    Object.keys(c).map(k => {
      c[k] = c[k].errorMessage;
    });
    return c;
  };

  const handleContactSupport = () => {
    setOpenSupport(true);
  };

  const updateTicket = () => {
    setLoading(true);
    const errors = validate();

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setLoading(false);
      return;
    }

    TicketApi.updateZendeskTicket(ticketId, {
      comment: form.comment,
      status: form.status,
    })
      .then(res => {
        console.log(res.data);
        if (res.data.error) {
          Alert.error(`There is an error updating ticket #${ticket?.zendeskId}. Please contact support!`);
          return;
        }
        Alert.success('Ticket Updated');
        setTimeout(() => {
          Router.push('https://www.soulrooms.com');
        }, 2000);
      })
      .catch(err => {
        console.error(err);
        Alert.error(`There is an error updating ticket #${ticketId}. Please contact support!`);
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <FlexboxGrid justify="space-around">
        <FlexboxGrid.Item style={{ textAlign: 'center', width: '100%' }} componentClass={Col} md={16} sm={16}>
          <H6>{ticket.souldroomsId ? `Respond to Request #${ticket.souldroomsId}` : `Update Ticket #${ticket.zendeskId}`}</H6>
        </FlexboxGrid.Item>
        <Form
          layout="horizontal"
          onCheck={setFormErrors}
          formError={formErrors}
          formValue={form}
          onChange={setForm}
          checkTrigger="change"
          model={Model}>
          <Panel shaded style={{ overflow: 'inherit', margin: '3% 0' }}>
            <FormGroup>
              <ControlLabel>Title</ControlLabel>
              <FormControl value={ticket?.briefDescription} plaintext></FormControl>
            </FormGroup>
            <FormGroup>
              <ControlLabel>Status</ControlLabel>

              <FormControl
                accepter={InputPicker}
                disabled={ticket.status === 'closed'}
                data={statusData}
                size="xs"
                placeholder="Status"
                name="status"></FormControl>
            </FormGroup>
            {ticket.status !== 'closed' && (
              <FormGroup>
                <ControlLabel>Comment</ControlLabel>

                <FormControl componentClass="textarea" rows={3} name="comment"></FormControl>
              </FormGroup>
            )}
            <FormGroup>
              <ButtonToolbar style={{ float: 'right' }}>
                <Button
                  style={{ width: '100px' }}
                  loading={loading}
                  size="xs"
                  onClick={() => setShowTicketInfo(true)}
                  appearance="ghost">
                  More Info
                </Button>
                <Button
                  style={{ width: '120px' }}
                  loading={loading}
                  size="xs"
                  onClick={ticket.status !== 'closed' ? updateTicket : handleContactSupport}
                  appearance="ghost">
                  {ticket.status !== 'closed' ? 'Update' : 'Contact Support'}
                </Button>
              </ButtonToolbar>
            </FormGroup>
          </Panel>
        </Form>
      </FlexboxGrid>
      {openSupport && (
        <SlackFeedback
          user={user}
          categories={['Feedback']}
          isOpen={openSupport}
          onClose={() => setOpenSupport(false)}></SlackFeedback>
      )}
      <TicketInfoModal ticket={ticket} show={showTicketInfo} setClose={setShowTicketInfo} />
    </>
  );
}

export default compose(UpdateZendeskTicket);
